import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["b2cFields", "b2bFields"]

  toggle(event) {
    const type = event.target.value
    this.b2cFieldsTarget.classList.toggle("hidden", type !== "particulier")
    this.b2bFieldsTarget.classList.toggle("hidden", type !== "entreprise")
  }
}
